import React from "react";
import { Avatar, Box, Tooltip } from "@mui/material";

const AwardCard = ({ award }) => {
  return (
      <Box
        display="flex"
        flexDirection= "column"
        justifyContent="center"
        alignItems="center"
        sx={{textAlign:"center", alignmentBaseline:"baseline"}}
      >
        <Tooltip title={award.name} arrow>
          <Avatar
            variant="rounded"
            sx={{ width: 150, height: 150 }}
            alt={award.name}
            src={`/static/images/${award.imageFileName??'default_award.png'}`}
          />
        </Tooltip>
      </Box>
  );
};

export default AwardCard;
